export enum ReservationProcessType {
  standard = 'Only allow booking requests',
  instant = 'Allow instant bookings',
}

export interface IReservationProcessType {
  type: 'standard' | 'instant';
}
